interface ErrorMessageProps {
  content: string
}

export default function ErrorMessage(props: ErrorMessageProps) {
  return (
    <div role="alert">
      <div className="rounded  bg-danger px-2 py-2 text-xs text-btn-fg">
        {props.content}
      </div>
    </div>
  )
}
